import { Typography } from '@mui/material'
import React, { FC } from 'react'
import { useAppType } from '../../contexts/AppTypeContext'

export const Copyright: FC = () => {
  const { config } = useAppType()
  const year = new Date().getFullYear()

  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {config.copyrightText(year)}
    </Typography>
  )
}
